/* Copyright (c) Epiphyte LLC 2022. All rights reserved.
Author: Fernandez-Alcon, Jose <jose@epiphyte.io>
 */

import React from "react";
import { LandingHeader } from "Components/LandingHeader";
import { Page } from 'grommet';

type Props = {}

const Landing: React.FC<Props> = (props) => {
    return (
        <Page kind={"wide"}>
            <LandingHeader/>
        </Page>
    )
}


export default Landing
